import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/_warranty-information.scss';
import {replaceLAZoneAbbrNow} from "../js/src/utils";

initMainHeader();
replaceLAZoneAbbrNow();

